<template>
    <div class="relative max-w-[300px]" :class="{'pointer-events-none' : !enable}">
        <p class="font-bold" :class="enable ? 'text-black' : 'text-gray-400'">{{title}}</p>
        <input type="text" :name="inputName" :class="{'bg-gray-300' : !enable}" class="form-input border rounded-2xl w-full selected:border-blue-800 border-gray-500
        text-black border-gray-[#707070] hover:bg-gray-300 focus:border-gray-300 transition-all"
        autocomplete="off" v-model="searchValue" :placeholder="value ? value.name : placeholder" @focus="modal = true; searchItems()">
        <div class="cursor-pointer absolute flex justify-center items-center right-0 -translate-y-full h-[42px] w-[42px] border-l-0">
            <Icon v-if="value" @click="value = ''" class="cursor-pointer" name="Fechar" />
            <Icon v-else name="Pesquisar"/>
        </div>

        <div v-show="filteredStates && modal && enable" class="relative">
            <ul class="absolute z-10 mt-2 p-0 m-0 overflow-auto border border-gray-300 bg-white border-b-0 max-h-[220px] noscroll rounded-2xl w-full">
                <label class="flex items-center gap-x-2 p-2 border-b border-gray-300 cursor-pointer hover:bg-gray-300 transition-all" v-for="filteredState in filteredStates" :key="filteredState.id || filteredState">
                    <input type="radio" v-model="value" :value="filteredState">
                    <p>{{filteredState.name}}</p>
                </label>
            </ul>
        </div>
    </div>
</template>
<script>

import Icon from "@/Components/UI/Icons/Icon.vue";

export default {
    components: {
        Icon
    },
    props: {
        title: String,
        items: Object,
        inputName: String,
        enable: {
            type: Boolean,
            default: true
        },
        options: {
            type: Object,
            default:
                {
                    clearWhenUpdateItems: false,
                    clearWhenSelectItemIsNotInTheList: false,
                },
        },
        onChange: Object,
        placeholder: String,
        modelValue: [Object, String, Array]
    },
    emits: ['update:modelValue'],
    data() {
        return {
            searchValue: '',
            modal: false,
            elSelected: '',
            filteredStates: []
        }
    },
    computed: {
        value: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
                this.modal = false;
            }
        }
    },
    watch: {
        searchValue: {
            handler() {
                if(this.modal) {

                    this.searchItems()
                }
            },
            immediate: true
        },
        items: {
            handler(newValue) {
                if(this.options.clearWhenUpdateItems) {
                    this.searchValue = '';
                    this.modal = false;
                    this.value = '';
                }

                if(this.options.clearWhenSelectItemIsNotInTheList) {
                    if(newValue.every(el => el.name != this.elSelected.name)) {
                        this.searchValue = '';
                        this.modal = false;
                        this.value = '';
                    }
                }
            },
            deep: true
        },
    },
    methods: {
        searchItems() {
            this.filteredStates = this.items.filter(state => {
                let merge = `${state.name.toLowerCase()} ${state.codeSap}`
                return merge.search(this.searchValue.toLowerCase()) != -1;
            })
        }
    },
}
</script>
<style scoped>
    .noscroll::-webkit-scrollbar {
        display: none; /* Hide scrollbar for Chrome, Safari and Opera */
    }
    .noscroll {
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
    }
</style>
